import React from 'react'

const AudioContext = React.createContext<any>({})

export const AudioContextProvider = AudioContext.Provider

export default AudioContext

